import API from "@/API";

const SET_DOCUMENT_TYPE = "SET_DOCUMENT_TYPE";
const SET_APPROVED = "SET_APPROVED";
const SET_PATHS = "SET_PATHS";
const SET_CONTENT = "SET_CONTENT";
const SET_EXTERNAL_ID = "SET_EXTERNAL_ID";

export default {
  namespaced: true,
  state: {
    document_type: "",
    approved: false,
    paths: {},
    external_id: "",
    content: {}
  },
  actions: {
    async createDocument({ dispatch }, account) {
      let data = await dispatch("buildData");

      try {
        await API.Documents.create(data, account);
      } catch (e) {
        throw e;
      }
    },
    async buildData({ state }) {
      return {
        document_type: state.document_type,
        approved: state.approved,
        paths: state.paths,
        external_id: state.external_id,
        content: state.content
      };
    },
    setPaths({ commit }, paths) {
      commit("SET_PATHS", paths);
    },
    setApproved({ commit }, answer) {
      commit("SET_APPROVED", answer);
    },
    setDocumentType({ commit }, document_type) {
      commit("SET_DOCUMENT_TYPE", document_type);
    },
    setContent({ commit }, content) {
      commit("SET_CONTENT", content);
    },
    setExternalId({ commit }, external_id) {
      commit("SET_EXTERNAL_ID", external_id);
    }
  },
  mutations: {
    [SET_PATHS](state, paths) {
      state.paths = paths;
    },
    [SET_APPROVED](state, answer) {
      state.approved = answer;
    },
    [SET_DOCUMENT_TYPE](state, document_type) {
      state.document_type = document_type;
    },
    [SET_CONTENT](state, content) {
      state.content = content;
    },
    [SET_EXTERNAL_ID](state, external_id) {
      state.external_id = external_id;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/newDocument.js